// removed by extract-text-webpack-plugin
module.exports = {"root":"_3afQbtq","inner":"_3jwZ-5s","root_isOpen":"Xvh3Mge","content":"_24LLsLp","prompt":"_1ztUH-p","learnMore":"_3y1H8vG","chevron":"_1A6f5eN","chevronSvg":"_1idRbRk","close":"_2AFQu2s","closeSvg":"_2hAekBr","enter":"_2rbbJMf","enter_Active":"nWJAKSz","leave":"_1CFj8K3","leave_Active":"_3_h6ERk"};


/*****************
 ** WEBPACK FOOTER
 ** ./app/components/PeekDown/PeekDown.less
 ** module id = 753
 ** module chunks = 0
 **/